import { render, staticRenderFns } from "./search-query-ranking-form.view.vue?vue&type=template&id=9e2853c6&scoped=true"
import script from "./search-query-ranking-form.view.vue?vue&type=script&lang=ts"
export * from "./search-query-ranking-form.view.vue?vue&type=script&lang=ts"
import style0 from "./search-query-ranking-form.view.vue?vue&type=style&index=0&id=9e2853c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2853c6",
  null
  
)

export default component.exports